import { FunctionComponent, useEffect } from 'react';
import { Stack, FormControl, InputLabel, OutlinedInput, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import EnergySupplierService from '../../../shared/services/energy-supplier/energy-supplier.service';
import { IPostEnergySupplier } from '../../../shared/services/energy-supplier/energy-supplier.model';

export const EnergySupplierDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  isEdit: boolean,
  energySupplierId?: string,
  isSubmitting: boolean,
  onSubmit: (values: IPostEnergySupplier, resetForm: () => void, isEdit: boolean, energySupplierId?: string) => void,
}> = ({
  open,
  closeHandler,
  isEdit,
  energySupplierId,
  isSubmitting,
  onSubmit
}) => {
    //Service
    const energySupplierService = new EnergySupplierService()

    const energySupplierSchema = Yup.object().shape({
      name: Yup.string().trim().required('Name is required'),
      details: Yup.string().trim().nullable(),
    })
    const formik = useFormik<IPostEnergySupplier>({
      validationSchema: energySupplierSchema,
      enableReinitialize: false,
      initialValues: {
        name: '',
        details: '',
      },
      onSubmit: (values, { resetForm }) => {
        onSubmit(values, resetForm, isEdit, energySupplierId)
      }
    })

    useEffect(() => {
      if (open && isEdit && energySupplierId) {
        energySupplierService.getOne(energySupplierId)
          .then(response => {
            formik.setFieldValue('name', response.name)
            formik.setFieldValue('details', response.details)
          })
          .catch(() => { })
      }
    }, [open, isEdit, energySupplierId])

    return (
      <DialogWrapper
        open={open}
        onClose={closeHandler}
        title={isEdit ? 'Edit Energy Supplier' : 'Add Energy Supplier'}
        cancelHandler={closeHandler}
        submitHandler={formik.submitForm}
        isSubmitting={isSubmitting}
        disableSaveButton={isSubmitting}
      >
        <Stack sx={{ mt: 1 }}>
          <FormControl fullWidth error={formik.touched.name && Boolean(formik.errors.name)}>
            <InputLabel htmlFor="energy-supplier-name">Name</InputLabel>
            <OutlinedInput
              id="energy-supplier-name"
              label="Name"
              value={formik.values.name || ''}
              onChange={(e) => formik.setFieldValue('name', e.target.value)}
            />
            <FormHelperText>
              {formik.touched.name && formik.errors.name ? formik.errors.name : ' '}
            </FormHelperText>
          </FormControl>
          {/* <FormControl fullWidth error={formik.touched.details && Boolean(formik.errors.details)}>
            <InputLabel htmlFor="energy-supplier-details">Additional Information</InputLabel>
            <OutlinedInput
              id="energy-supplier-details"
              label="Additional Information"
              value={formik.values.details || ''}
              onChange={(e) => formik.setFieldValue('details', e.target.value)}
              onBlur={formik.handleBlur}
            />
            <FormHelperText>
              {formik.touched.details && formik.errors.details ? String(formik.errors.details) : ' '}
            </FormHelperText>
          </FormControl> */}
        </Stack>
      </DialogWrapper>
    )
  }


